export default __webpack_public_path__ + "static/media/dalabtire-mark.78ce7171.png";